import React from 'react';
import { XStack, XStackProps } from 'tamagui';

// This component will take in the left, middle, and right card content as props
interface ThreeCardLayoutProps {
  left?: React.ReactNode;
  middle?: React.ReactNode;
  right?: React.ReactNode;
  middleProps?: XStackProps;
  leftProps?: XStackProps;
  rightProps?: XStackProps;
}

export const ThreeCardLayout: React.FC<ThreeCardLayoutProps> = ({
  left,
  middle,
  right,
  leftProps,
  middleProps,
  rightProps,
}) => (
  <XStack width="100%" height="100%" padding="$10" gap="$10">
    <XStack justifyContent="flex-start" alignItems="center" flex={1} {...leftProps}>
      {left}
    </XStack>
    <XStack justifyContent="center" alignItems="center" flex={1} {...middleProps}>
      {middle}
    </XStack>
    <XStack justifyContent="flex-end" alignItems="center" flex={1} {...rightProps}>
      {right}
    </XStack>
  </XStack>
);
